<section class="page-heading">
  <a [mat-dialog-close]="undefined" class="close-button" mat-icon-button type="button" tabindex="-1">
    <mat-icon class="notranslate">close</mat-icon>
  </a>
  <h1>Open {{isGpSide ? 'CRE' : 'Investor'}} Bank Account</h1>
  <h2 class="page-sub-header">
    Please fill out the form with the relevant information.
    <ng-container *ngIf="isGpSide">
      <br>
      Signature users will be notified and have to approve the creation of this bank account.
    </ng-container>
  </h2>
</section>

<ng-template #loadingPage>
  <terra-loader class="page-loader"></terra-loader>
</ng-template>

<ng-container *ngIf="dataLoaded$ && (dataLoaded$ | async) else loadingPage">
  <form (ngSubmit)="continue()" [formGroup]="pageForm" id="bankAccountForm">
    <div class="cov-form">
      <!-- General -->
      <section class="form-section">
        <h3 class="section-title">Account Details</h3>
        <div class="form-fields">

          <!-- Holdings -->
          <div class="terra-form-field-wrapper large-field" *ngIf="preselectedType == unitApplicationParentType.Holding">
            <label class="text-input-label" for="ddlHolding">Asset/Fund</label>
            <mat-form-field appearance="outline" class="filter" *ngIf="!(isPreselectedHolding$ | async)">
              <mat-select formControlName="holding" id="ddlHolding" panelClass="holdings-select-panel"
                placeholder="Select">
                <mat-option>Select</mat-option>

                <mat-option *ngFor="let holding of selectableHoldings$ | async; trackBy: holdingTrackByFn"
                  [value]="holding" class="lo_sensitive">
                  {{ holding.name }}
                </mat-option>
                <!-- <mat-divider></mat-divider> -->

                <!-- <mat-option *ngFor="let holding of disabledHoldings$ | async; trackBy: holdingTrackByFn" [value]="holding">
                  <span class="holding-without-application-option lo_sensitive">{{ holding.name }}</span>
                </mat-option> -->
              </mat-select>


              <mat-error *ngIf="pageForm.get('holding').hasError('required')">
                Required
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="filter" *ngIf="(isPreselectedHolding$ | async)">
              <input readonly class="preselected-holding lo_sensitive" id="txtPreselectedHolding" matInput
                value="{{(preselectedHolding$ | async)?.name}}" />
            </mat-form-field>
          </div>

          <!-- Account nickname -->
          <div class="terra-form-field-wrapper large-field">
            <label class="text-input-label" for="txtAccountNickname">Account Nickname</label>
            <mat-form-field appearance="outline">
              <input autocomplete="bank-account-nickname" class="lo_sensitive" formControlName="accountNickname"
                id="txtAccountNickname" matInput placeholder="e.g Contributions ABC" />
              <mat-error *ngIf=" pageForm.get('accountNickname').hasError('required')">
                Required
              </mat-error>
              <mat-error *ngIf="pageForm.get('accountNickname').getError('maxlength') as error">
                Please enter up to {{error.requiredLength}} characters
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Deposit product (Account type): Investor, Operational, Security or Other -->

          <div class="terra-form-field-wrapper small-field" *ngIf="preselectedType === unitApplicationParentType.Holding">
            <label class="text-input-label label-account-type" for="ddlAccountType">Account Type
<!--              <mat-icon (click)="isOverlayOpen = !isOverlayOpen" cdkOverlayOrigin #trigger="cdkOverlayOrigin">info</mat-icon>-->
            </label>
            <mat-form-field appearance="outline">
              <mat-select formControlName="accountType" id="ddlAccountType" placeholder="Select">
                <mat-option *ngFor="let accountType of accountTypeList" [value]="accountType">{{accountType | enumString:UnitAccountType}}</mat-option>
              </mat-select>
              <mat-error *ngIf="pageForm.get('accountType').hasError('required')">Required</mat-error>
            </mat-form-field>

<!--            <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOverlayOpen">-->
            <!--              <ul class="account-types-tooltip">-->
            <!--                <li><span>Primary -</span><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></li>-->
            <!--                <li><span>CAPEX -</span><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></li>-->
            <!--                <li><span>Operations -</span><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></li>-->
            <!--                <li><span>Security Deposit -</span><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></li>-->
            <!--                <li><span>Reserve -</span><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></li>-->
            <!--                <li><span>Other -</span><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span></li>-->
            <!--              </ul>-->
            <!--            </ng-template>-->
          </div>
        </div>
      </section>
    </div>

    <!-- Message when selected holding is not allowed (there is no approved application) -->
    <!-- <section *ngIf="(isSelectedHoldingAllowed$ | async) === false" class="selected-holding-not-allowed">
      <ng-container *ngIf="selectedHolding$ | async as holding">
        <div class="messages">
          <p *ngIf="!holding.unitApplicationId" class="info-message">
            In order to open a CRE Bank account for this {{ holding.discriminator | enumString: HoldingDiscriminator : true}},
            you need to apply for CRE Banking. Start the process by clicking on the following button.
          </p>
          <p *ngIf="holding.unitApplicationId" class="info-message">
            Application not yet approved.
          </p>
        </div>

        <div class="actions">
          <a *ngIf="!holding.unitApplicationId" [routerLink]="createApplicationUrl"
             [state]="{ holdingId: holding.id }"
             class="cov-button submit-application-button"
             color="primary" mat-flat-button>
            Submit Application for this {{ holding.discriminator | enumString : HoldingDiscriminator}}
          </a>
          <a *ngIf="holding.unitApplicationId" [routerLink]="selectedHoldingsApplicationPageUrl$ | async" class="cov-button view-application-button"
             color="primary" mat-flat-button>
            View application status
          </a>
        </div>
      </ng-container>
    </section> -->

    <!-- Fees section -->
    <ng-container *ngIf="{
      fees: fees$ | async,
      isShowFees: isShowFees$ | async}
      as feesContext">
      <section *ngIf="feesContext.fees && feesContext.isShowFees">
        <h3 class="section-title">Account Fees</h3>
        <p class="description">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin maximus sem ac libero convallis egestas.
          Suspendisse molestie, ligula non consectetur viverra.
        </p>
        <terra-unit-bank-account-fees-table [fees]="feesContext.fees"></terra-unit-bank-account-fees-table>
      </section>
    </ng-container>


    <!-- We hide the continue and cancel buttons if the selected holding is not allowed, because other buttons appear instead.
      If the holding is not yet selected, we display these buttons (otherwise it looks strange that there are no buttons at all) -->
    <section class="form-footer">
      <!-- Error message -->
      <div *ngIf="!pageForm.valid && pageForm.touched" class="error-section">
        <p *ngIf="!pageForm.valid" class="error-message">
          Please review and correct the fields marked in red
        </p>
      </div>

      <!-- <div class="messages">
        <p *ngIf="pageForm.get('holding')?.value && (selectedHoldingHasBankAssigned$ | async)" class="info-message">
          Holding {{pageForm.get('holding').value.name}} already has a bank account assigned
        </p>
      </div> -->

      <div class="actions">
        <button [disabled]="!pageForm.valid" class="cov-button continue-button" color="primary" form="bankAccountForm"
          mat-flat-button type="submit">
          Create
        </button>

        <!-- <button *ngIf="showExternalOption" type="button" class="cancel-button cov-button" mat-stroked-button
          (click)="closeDialog()">
          Add existing account instead
        </button>

        <button *ngIf="!showExternalOption" type="button" [mat-dialog-close]="undefined"
          class="cancel-button cov-button" mat-stroked-button>
          Cancel
        </button> -->
      </div>
    </section>
  </form>
</ng-container>
